var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsOptional, IsUUID } from 'class-validator';
/**
 * Patient request for free slots for a Folgeverordnung (PRD #1343, RS-011). The
 * new episode continues an exhausted/expiring predecessor plan, so — unlike the
 * "egal" first-contact search — the slot search is scoped server-side to that
 * episode's continuity therapist (and the therapist's mirrored duration). The
 * patient sends the predecessor plan and the primary Heilmittel they scanned or
 * typed; the redacted projection (free times + continuity therapist name) is
 * returned.
 */
export class FindPatientFolgeverordnungSlotsDto {
    /** The predecessor plan whose continuity therapist scopes the search. */
    predecessorPlanId;
    /** The primary Heilmittel (from the scanned/typed Folgeverordnung) driving the search. */
    treatmentConceptId;
    /** Earliest day to search from (defaults to "today" server-side when omitted). */
    searchFrom;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], FindPatientFolgeverordnungSlotsDto.prototype, "predecessorPlanId", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], FindPatientFolgeverordnungSlotsDto.prototype, "treatmentConceptId", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], FindPatientFolgeverordnungSlotsDto.prototype, "searchFrom", void 0);
//# sourceMappingURL=find-patient-folgeverordnung-slots.dto.js.map